import { Box } from '@mui/material';
import Photos from '../../../../components/Media/Photos/Photos';
import { IUser } from '../../../../interfaces/user.interface';

interface PhotosTabProps {
  user?: IUser;
}

const PhotosTab = ({ user }: PhotosTabProps) => {
  return (
    <Box id="photos">
      <Photos user={user} />
    </Box>
  );
};

export default PhotosTab;
